<!-- =========================================================================================
  File Name: BookAddTabInformation.vue
  Description: Book Add Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>

    <!-- Content Row -->
    <div class="vx-row"> 
      <div class="vx-col md:w-1/2 w-full">
        <vs-select class="mt-4 w-full" v-model="metaType" label="데이타 타입" name="metaType" v-validate="'required'">
          <vs-select-item :key="item.key" :value="item.key" :text="item.label" v-for="item in metaTypeOptions" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('metaType')">{{ errors.first('metaType') }}</span>
  
        <vs-input class="w-full mt-4" v-model="metaCode" label="데이타 코드" v-validate="'required'" name="metaCode" placeholder="영문+숫자 조합"/>
        <span class="text-danger text-sm" v-show="errors.has('metaCode')">{{ errors.first('metaCode') }}</span>

        <vs-input class="w-full mt-4" v-model="metaValue" label="데이타 값" v-validate="'required'" name="metaValue" placeholder=""/>
        <span class="text-danger text-sm" v-show="errors.has('metaValue')">{{ errors.first('metaValue') }}</span>

        <vs-input class="w-full mt-4" type="number" v-model="metaOrder" label="순서" v-validate="'required'" name="metaOrder" placeholder=""/>
        <span class="text-danger text-sm" v-show="errors.has('metaOrder')">{{ errors.first('metaOrder') }}</span>

      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="confirmSave" :disabled="!validateForm">저장</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="onBack">취소</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { postData } from '@/api/module'

export default {
  components: {
  },
  data () {
    return {
      metaTypeOptions: [
        {
          label: 'Unit',
          key:'UNIT'
        },
        {
          label: 'Step',
          key:'STEP'
        },
        {
          label: 'Menu',
          key:'MENU'
        }
      ],
      metaType: '',
      metaCode: '',
      metaValue: '',
      metaOrder: 0
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    confirmSave () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '교재 메타정보 추가',
        text: '추가 하시겠습니까?',
        accept: this.save,
        acceptText: '저장'
      })
    },
    onBack () {
      this.$router.go(-1)
    },
    async save () {
      if (!this.validateForm) return

      try {
        const bookSeq = this.$route.params.bookSeq
        await postData(`/book/${bookSeq}/meta`, {
          metaType: this.metaType,
          metaCode: this.metaCode,
          metaValue: this.metaValue,
          metaOrder: this.metaOrder
        })
        
        this.$vs.loading.close()
        this.$router.push(`/book/book-view/${bookSeq}`)

      } catch (error) {
        // console.log(error.response.data.msg);
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }
  }
}
</script>
